import React, { Component } from 'react';

export class NoMatch extends Component {
    render() {
        return (<h1 id='noMatch'>{'404 - Whoopsie'}</h1>);
    }
}
